import { N0 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

export const HEADER_BACKGROUND_COLOR = token('elevation.surface', N0);
